import { HostingEnvironment, Permission } from "@octopusdeploy/octopus-server-client";
import { repository } from "~/clientInstance";
import store from "../../../store";
import { isAllowed } from "../../PermissionCheck/PermissionCheck";
import type { NotificationItem } from "../notifications.redux";
import { notificationActions } from "../notifications.redux";
import { NotificationPoller } from "./NotificationPoller";
export default class CloneDetectionNotificationPoller extends NotificationPoller {
    notificationId: string = "Notification/CloneDetection";
    notificationCheck = async () => {
        const status = await repository.ServerStatus.getServerStatus();
        if (!status.IsPotentialClone) {
            // Clear any previously raised notification
            store.dispatch(notificationActions.dismissNotification(this.notificationId));
            return;
        }
        // Only show for self-hosted instances
        const licenseStatus = await repository.Licenses.getCurrentStatus();
        if (licenseStatus.HostingEnvironment === HostingEnvironment.OctopusCloud)
            return;
        // Only show for admins
        if (!isAllowed({ permission: Permission.AdministerSystem }))
            return;
        const notification: NotificationItem = {
            id: this.notificationId,
            type: "warn",
            text: "Potential cloned database detected.",
            description: "This server appears to be connecting to a pre-existing database for the first time. If it was cloned from another instance, the Installation ID must be updated to prevent telemetry conflicts. If this is a new node being added to an existing HA cluster, this warning can be safely ignored.",
            links: [
                {
                    type: "External",
                    label: "How to update the Installation ID",
                    href: "https://octopus.com/docs/administration/upgrading/guide/creating-test-instance",
                },
            ],
        };
        this.raiseNotification(notification);
    };
}
